import React, { useId } from "react";
import classNames from "classnames";
import cls from "./styles.module.scss";

type BackgroundStripesColor = "yellow" | "green" | "gray";

interface BackgroundStripesProps {
  color?: BackgroundStripesColor;
  className?: string;
}

export const BackgroundStripes: React.FC<BackgroundStripesProps> = ({
  color = "yellow",
  className,
}) => {
  const id = useId().replace(/:/g, "");
  const firstGradientId = `stripes-first-${id}`;
  const secondGradientId = `stripes-second-${id}`;
  const thirdGradientId = `stripes-third-${id}`;

  return (
    <svg
      className={classNames(cls.wrapper, cls[color], className)}
      viewBox="0 0 360 553"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      preserveAspectRatio="none"
    >
      <rect
        opacity="0.25"
        x="-65.1492"
        y="448.34"
        width="42.5721"
        height="545.324"
        transform="rotate(-150 -65.1492 448.34)"
        fill={`url(#${firstGradientId})`}
      />
      <rect
        opacity="0.25"
        x="64.8005"
        y="552.35"
        width="42.5721"
        height="665.425"
        transform="rotate(-150 64.8005 552.35)"
        fill={`url(#${secondGradientId})`}
      />
      <rect
        opacity="0.25"
        x="248"
        y="552.35"
        width="42.5721"
        height="665.425"
        transform="rotate(-150 248 552.35)"
        fill={`url(#${thirdGradientId})`}
      />
      <defs>
        <linearGradient
          id={firstGradientId}
          x1="-50.2437"
          y1="478.521"
          x2="-33.8631"
          y2="952.381"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.13554" stopColor="currentColor" stopOpacity="0" />
          <stop offset="1" stopColor="currentColor" />
        </linearGradient>
        <linearGradient
          id={secondGradientId}
          x1="77.5847"
          y1="559.799"
          x2="96.5553"
          y2="1136.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.153681" stopColor="currentColor" stopOpacity="0" />
          <stop offset="1" stopColor="currentColor" />
        </linearGradient>
        <linearGradient
          id={thirdGradientId}
          x1="260.784"
          y1="559.799"
          x2="279.755"
          y2="1136.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.153681" stopColor="currentColor" stopOpacity="0" />
          <stop offset="1" stopColor="currentColor" />
        </linearGradient>
      </defs>
    </svg>
  );
};
